import { FormError, themeStyled as styled } from '@parapet/common';

export const FormRowError = styled.div`
  font-size: 12px;
  color: var(--input-error-text, red);
  padding: 8px 8px 0 8px;
`;

export const LoginAuthError = styled(FormError)`
  flex-direction: column;
  text-align: center;
  > svg {
    margin: 0 0 4px 0;
    animation: flash 1s ease infinite;
  }
  b {
    display: block;
    margin-bottom: -6px;
  }
`;
